import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ScrollContext } from 'react-router-scroll-4'
import { I18nextProvider } from 'react-i18next'

import ApolloClient from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloLink } from 'apollo-link'
import { withClientState } from 'apollo-link-state'

import { createHttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'

import { ApolloProvider } from 'react-apollo'

import i18n from './i18n'

import AppContent from './AppContent'
//import ErrorBoundary from './components/error_handling'

import { Auth0Provider } from './authentication/Auth0Provider.js'
import { AtokenFromAuth0Provider } from './authentication/AtokenFromAuth0Provider.js'

import resolvers from './apollo/resolvers'

// Logging only in debug mode - check other option?
//const DEBUG = (process.env.NODE_ENV) !== 'production')

// AtokenProvider communicates atoken back to authLink here
const aTokenStore = {atoken: null}

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_APP_SYNC_GRAPHQL_ENDPOINT
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const atoken = aTokenStore.atoken
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: atoken
    }
  }
})

const cache = new InMemoryCache()

const stateLink = withClientState({
  cache,
  resolvers
})

export const client = new ApolloClient({
  //link: authLink.concat(httpLink),
  link: ApolloLink.from([
    stateLink,
    authLink.concat(httpLink)
  ]),
  cache: cache,
  defaultOptions: {
    query: {
      fetchPolicy: 'cache-and-network'
    },
    watchQuery: {
      errorPolicy: 'all'
    }
  }
})

const App = () => (
  <ApolloProvider client={client}>
    <I18nextProvider i18n={i18n}>
      {/*<ErrorBoundary>*/}
        <BrowserRouter>
          <ScrollContext>
            <Auth0Provider>
              <AtokenFromAuth0Provider redirect_path='/home' store={aTokenStore} >
                <AppContent />
              </AtokenFromAuth0Provider>
            </Auth0Provider>
          </ScrollContext>
        </BrowserRouter>
      {/*</ErrorBoundary>*/}
    </I18nextProvider>
  </ApolloProvider>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js